export default {
  isOpen: state => state.isOpen,
  isActive: state => state.isActive,
  isNotFound: state => state.isNotFound,
  isDisable: state => state.isDisable,
  currentFilter: state => state.currentFilter,
  savedFilters: state => state.savedFilters,
  activeFilters: state => state.activeFilters,
  getActiveFilterByTypeOrProjectId: state => key => state.activeFilters[key] || null,
  getActiveFilterByParams: state => (filterName, key = null) => {
    let filterData = state.activeFilters[filterName];

    if (!filterData) {
      return null;
    }

    if (key) {
      filterData = filterData[key];
    }

    return filterData;
  },
  getAllSavedFilters: state => state.savedFilters,
  getSavedFiltersByType: state => type => state.savedFilters[type] || [],
  // getAdvancedSettingsByFilterType: state => type => state.advancedSettings[type] || null,
  getAdvancedSettingsByFilterType: state => type => {
    const original = state.advancedSettings[type];

    return original ? { ...original } : null;
  },
};
